import React from 'react';
import './App.css';
import Navbar from './components/Header/Header'
import Hero from './components/Hero/Hero'

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
    </div>
  );
}

export default App;